import React from "react";
import { Link, useLocation } from "react-router-dom";

const TabMenuChain4 = () => {
  const location = useLocation();

  return (
    <>
      <ul>
        <li>
          <Link
            to="/deposit/lava"
            className={`${location.pathname == "/" ? "active" : location.pathname == "/deposit/lava" ? "active" : ""}`}
          >
            Deposit
          </Link>
        </li>
        <li>
          <Link
            to="/withdraw/lava"
            className={`${location.pathname == "/withdraw/lava" ? "active" : ""}`}
          >
            Withdraw
          </Link>
        </li>
      </ul>
    </>
  );
};

export default TabMenuChain4;
